import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=199aee5d&scoped=true&"
import script from "./exhibition.vue?vue&type=script&lang=js&"
export * from "./exhibition.vue?vue&type=script&lang=js&"
import style0 from "./exhibition.vue?vue&type=style&index=0&id=199aee5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199aee5d",
  null
  
)

export default component.exports